import { render } from "./QuickSearch.vue?vue&type=template&id=5750ad5f&scoped=true"
import script from "./QuickSearch.vue?vue&type=script&lang=ts"
export * from "./QuickSearch.vue?vue&type=script&lang=ts"

import "./QuickSearch.vue?vue&type=style&index=0&id=5750ad5f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5750ad5f"

export default script